import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectToolCollection } from "../../../actions";
import "./ProductInfo.css";
import Pricing from "./Pricing/";

class ProductInfo extends React.Component {
  componentDidMount() {
    // Set 'ProductInfo' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Product Info" });
  }

  render() {
    return (
      <div className="tools-container tools-container--info">
        <div className="tool tool--info">
          <h4 className="tool__header">Product Info</h4>
          <div
            className="tool__options"
            dangerouslySetInnerHTML={{ __html: this.props.product_info }}
          ></div>
        </div>
        {/*
         <Pricing
          pricing={this.props.pricing}
        />
*/}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    product_info: state.design.present.product_info,
    pricing: state.design.present.pricing,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      selectToolCollection,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductInfo);
